export class PromiseResolveCallback<T = unknown> {

  promise: Promise<T>
  resolveFn: (value: T | PromiseLike<T>) => void = () => {}
  rejectFn: (reason?: unknown) => void = () => {}

  constructor () {
    this.promise = new Promise((resolve, reject) => {
      this.resolveFn = resolve
      this.rejectFn = reject
    })
  }

  resolve = (value: T) => {
    this.resolveFn(value)
  }

  reject = (reason?: unknown) => {
    this.rejectFn(reason)
  }
}
